const renderDonutChart = (result) => {
    console.log(result);
    return (
        <div className="donut-chart">
         <div className="svg-item">
                <svg width="100%" height="100%" viewBox="0 0 50 50" className="donut">
                    <circle className="donut-hole" cx="25" cy="25" r="15.91549430918954" fill="#fff"></circle>
                    <circle className={result ? 'donut-ring' : 'donut-ring-disable' } cx="25" cy="25" r="15.91549430918954" fill="transparent" strokeWidth="9.5"></circle>
                    <circle className='donut-segment donut-segment-2' cx="25" cy="25" r="15.91549430918954" fill="transparent" strokeWidth="9.5"
                     strokeDasharray={`${result} ${100-result}`} strokeDashoffset="25"></circle>
 
                    </svg>
            </div>
       
        </div>
    )
}
export {renderDonutChart};